// extracted by mini-css-extract-plugin
module.exports = {"cherryInfoWrapper":"ClientCherryInfo_cherryInfoWrapper__38SNi","title":"ClientCherryInfo_title__AzXQK","itemText":"ClientCherryInfo_itemText__2OYL3"};